/* Festive hero: crossfading slides, dots, swipe, and the hand-over to the site
   header once the hero has scrolled off a phone screen. */
(function () {
  var hero = document.querySelector('[data-fhero]');
  if (!hero) return;

  /* ---- header hand-over (the CSS only acts on it below 900px) ---- */
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      document.body.classList.toggle('fhero-past', !entries[0].isIntersecting);
    }, { rootMargin: '-72px 0px 0px 0px' }).observe(hero);
  } else {
    document.body.classList.add('fhero-past');
  }

  /* ---- slides ---- */
  var slides = [].slice.call(hero.querySelectorAll('[data-slide]'));
  var dots = [].slice.call(hero.querySelectorAll('[data-dot]'));
  if (slides.length < 2) return;

  var index = 0;
  var timer = null;
  var interval = parseInt(hero.getAttribute('data-interval'), 10) || 5000;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function show(n) {
    index = (n + slides.length) % slides.length;
    slides.forEach(function (s, i) {
      var on = i === index;
      s.classList.toggle('is-active', on);
      if (on) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
      [].forEach.call(s.querySelectorAll('a'), function (a) {
        if (on) { a.removeAttribute('tabindex'); } else { a.setAttribute('tabindex', '-1'); }
      });
      var img = s.querySelector('img[loading="lazy"]');
      if (on && img) img.loading = 'eager';
    });
    dots.forEach(function (d, i) { d.setAttribute('aria-selected', i === index ? 'true' : 'false'); });
  }

  function play() {
    if (still) return;
    stop();
    timer = setInterval(function () { show(index + 1); }, interval);
  }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }

  dots.forEach(function (d) {
    d.addEventListener('click', function () { show(+d.getAttribute('data-dot')); play(); });
  });

  hero.addEventListener('mouseenter', stop);
  hero.addEventListener('mouseleave', play);
  hero.addEventListener('focusin', stop);
  hero.addEventListener('focusout', play);
  document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { play(); } });

  var x0 = null;
  hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
  hero.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
    x0 = null;
    play();
  }, { passive: true });

  play();
})();
